import { USAGE_BILLING_ENABLED } from 'components/admin/utils/feature-flags';
import { useFeatureFlags } from 'controllers/contexts/featureFlags';

export function useGetUsageBillingEnabled(): boolean {
  const { hasFlag }: any = useFeatureFlags();
  return !!hasFlag(USAGE_BILLING_ENABLED);
}
